import React from 'react';
import { Layout, Header } from '../components/Layout';
import { Handshake, Building2, Phone, Mail, ArrowRight } from 'lucide-react';

const AutoDealerContact = () => {
  return (
    <Layout>
      <Header title="Auto Dealer Contact" />
      <div className="p-6 flex items-center justify-center min-h-[calc(100vh-4rem)]" data-testid="auto-dealer-page">
        <div className="max-w-lg w-full text-center">
          <div className="relative mb-8">
            <div className="w-24 h-24 mx-auto bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl flex items-center justify-center shadow-lg shadow-blue-500/25 animate-pulse">
              <Handshake className="w-12 h-12 text-white" />
            </div>
            <div className="absolute -top-2 -right-2 w-8 h-8 bg-amber-400 rounded-full flex items-center justify-center text-white text-xs font-bold animate-bounce" style={{left: 'calc(50% + 32px)'}}>
              !
            </div>
          </div>

          <h2 className="text-3xl font-bold text-slate-900 mb-3">Coming Soon</h2>
          <p className="text-lg text-slate-600 mb-2">Auto Dealer Partnerships</p>
          <p className="text-sm text-slate-500 mb-8 max-w-sm mx-auto">
            We're building partnerships with auto dealers across the nation. Stay tuned for exclusive dealer rates and direct integration.
          </p>

          <div className="bg-gradient-to-br from-slate-50 to-blue-50 border border-slate-200 rounded-xl p-6 mb-6">
            <div className="flex items-center justify-center gap-3 mb-4">
              <Building2 className="w-5 h-5 text-blue-600" />
              <span className="font-semibold text-slate-900">Shumail Technologies LLC</span>
            </div>
            <div className="flex items-center justify-center gap-6 text-sm text-slate-600">
              <span className="flex items-center gap-1.5">
                <Phone className="w-4 h-4 text-slate-400" />
                Contact Us
              </span>
              <span className="flex items-center gap-1.5">
                <Mail className="w-4 h-4 text-slate-400" />
                info@breamway.com
              </span>
            </div>
          </div>

          <div className="inline-flex items-center gap-2 text-sm text-blue-600 font-medium">
            <span>Interested in partnering?</span>
            <ArrowRight className="w-4 h-4" />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AutoDealerContact;
